// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.amenities.apartments.RentalManagerUserPropertyApartmentAmenityWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyApartmentAmenityWebApiHandler_create,
  RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyApartmentAmenityCreateResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface CreateParams {
  availableInSelectUnits?: boolean;
  listingAlias: ListingAlias;
  text: string;
}
interface DeleteParams {
  amenityId: string;
}

export interface RentalManagerUserPropertyApartmentAmenityWebApiHandler_create_Args {
  getParams: CreateParams;
}

export type RentalManagerUserPropertyApartmentAmenityWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyApartmentAmenityCreateResponseWebDto,
  unknown,
  RentalManagerUserPropertyApartmentAmenityWebApiHandler_create_Args
>;

/**
 * Create a free text apartment amenity
 * @deprecated
 */
export const useRentalManagerUserPropertyApartmentAmenityWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyApartmentAmenityWebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyApartmentAmenityWebApiHandler_create_Args) =>
      RentalManagerUserPropertyApartmentAmenityWebApiHandler_create(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete_Args
>;

/**
 * Delete a free text apartment amenity
 * @deprecated
 */
export const useRentalManagerUserPropertyApartmentAmenityWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyApartmentAmenityWebApiHandler_delete(args.getParams, httpClient),
  });
};
